import { useTranslation } from 'react-i18next';
import { es } from 'date-fns/locale';
import { enUS } from 'date-fns/locale';

export function useDateLocale() {
  const { i18n } = useTranslation();
  return i18n.language?.startsWith('en') ? enUS : es;
}
